<template>
  <div class="pricing"></div>
</template>

<script>
export default {
  name: "Pricing",
};
</script>

<style lang="scss" scoped>
.pricing {
  position: absolute;
  bottom: -240px;
  left: -110px;
  width: 400px;
  height: 400px;
  border-radius: 100%;
  background-color: rgba(255, 255, 255, 0.65);
  -webkit-transition: background-color 0.35s ease-in-out;
  -moz-transition: background-color 0.35s ease-in-out;
  -ms-transition: background-color 0.35s ease-in-out;
  -o-transition: background-color 0.35s ease-in-out;
  transition: background-color 0.35s ease-in-out;
}
</style>
